import { type } from 'arktype';

export const createTimetrackingAbsenceSchema = type({
  'source?': 'string',
  'externalId?': 'string',
  personId: 'string',
  dateFrom: 'string',
  'dateTo?': 'string | null',
  'absenceType?': 'string',
  'title?': 'string',
  'description?': 'string | null',
  'color?': 'string | null',
  'meta?': 'unknown',
});

export type CreateTimetrackingAbsence = typeof createTimetrackingAbsenceSchema.t;

export const pushTimetrackingAbsencesSchema = type({
  absences: createTimetrackingAbsenceSchema.array(),
});

export type PushTimetrackingAbsences = typeof pushTimetrackingAbsencesSchema.t;

export const updateTimetrackingAbsenceSchema = type({
  'source?': 'string',
  'externalId?': 'string | null',
  'personId?': 'string',
  'dateFrom?': 'string',
  'dateTo?': 'string | null',
  'absenceType?': 'string',
  'title?': 'string',
  'description?': 'string | null',
  'color?': 'string | null',
  'meta?': 'unknown',
});

export type UpdateTimetrackingAbsence = typeof updateTimetrackingAbsenceSchema.t;

export interface TimetrackingAbsence {
  absenceId: string;
  personId: string;
  calendarId: string;
  calendarSlotId: string;
  dateFrom: string;
  dateTo: string | null;
  source: string;
  externalId: string | null;
  absenceType: string;
  title: string;
  description: string | null;
  color: string;
  meta: unknown;
  createdAt: string;
  updatedAt: string;
}

export interface TimetrackingAbsencePushResult {
  source: string;
  externalId: string | null;
  calendarId: string;
  calendarSlotId: string;
  absenceId: string;
  status: 'created' | 'updated';
}

export interface TimetrackingAbsencePushResponse {
  processed: number;
  results: TimetrackingAbsencePushResult[];
}
